<template><micro-schema :ld-json-data="jsonData" /></template>
<script lang="ts" setup>
import { isEmpty } from "lodash-es";
import { type MicroSchemaCategoryListItem as MicroSchemaCategoryListItemType } from "../interfaces";
import { SCHEMA_CONTEXT_LINK } from "../variables";
import { ProductShort } from "~/types/product";
import { MicroSchema } from "~/modules/micro-schema/components/MicroSchema";

const { productLink } = useCatalogLinker();

const props = defineProps<{
  products: ProductShort[];
  sort: string;
}>();

const currentProducts = computed<ProductShort[]>(() => props.products);
const jsonData = computed<MicroSchemaCategoryListItemType | undefined>(() => {
  if (isEmpty(currentProducts.value)) {
    return undefined;
  }

  return {
    "@context": SCHEMA_CONTEXT_LINK,
    "@type": "ItemList",
    numberOfItems: currentProducts.value.length ?? 0,
    itemListOrder: props.sort,
    itemListElement: currentProducts.value.map((i, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      name: i.name,
      image: i.thumbnail.url,
      identifier: i.sku,
      url: productLink(i, { withDomain: true }),
    })),
  };
});
</script>
